<script setup>
import { computed } from 'vue';

const props = defineProps({
  attribution: { type: Object, default: () => ({}) },
});

const hasAttribution = computed(
  () => Object.keys(props.attribution).length > 0
);
const platform = computed(() => props.attribution.platform || 'Facebook Ads');
const source = computed(() => props.attribution.source || 'Click to WhatsApp');
const mediaUrl = computed(() => props.attribution.media_url);
const sourceUrl = computed(() => props.attribution.url);
</script>

<template>
  <section
    v-if="hasAttribution"
    class="mx-2 mb-3 overflow-hidden rounded-xl border border-n-weak bg-n-alpha-1"
  >
    <div class="flex items-center gap-2 border-b border-n-weak px-3 py-2">
      <span class="i-lucide-megaphone size-4 text-n-blue-11" />
      <p class="text-sm font-semibold text-n-slate-12">
        {{ $t('CONVERSATION_SIDEBAR.ADS.TITLE') }}
      </p>
    </div>
    <div class="flex gap-3 p-3">
      <img
        v-if="mediaUrl"
        :src="mediaUrl"
        :alt="$t('CONVERSATION_SIDEBAR.ADS.MEDIA_ALT')"
        class="size-16 shrink-0 rounded-lg object-cover bg-n-alpha-2"
      />
      <div class="min-w-0 space-y-1">
        <p class="text-xs font-medium text-n-blue-11">
          {{ platform }} · {{ source }}
        </p>
        <p
          v-if="attribution.headline"
          class="truncate text-sm font-semibold text-n-slate-12"
        >
          {{ attribution.headline }}
        </p>
        <p v-if="attribution.body" class="line-clamp-2 text-xs text-n-slate-11">
          {{ attribution.body }}
        </p>
        <a
          v-if="sourceUrl"
          :href="sourceUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex text-xs font-medium text-n-blue-11 hover:underline"
        >
          {{ $t('CONVERSATION_SIDEBAR.ADS.OPEN') }}
        </a>
      </div>
    </div>
  </section>
</template>
